import { useLayoutEffect, useRef, type RefObject } from "react";

/**
 * Ref that mirrors the latest committed `value`, for effects, timers and
 * native listeners that must read current props without re-subscribing.
 *
 * Only read it outside render; render-time consumers should use `value`.
 */
export function useLatestRef<T>(value: T): RefObject<T> {
  const ref = useRef(value);

  useLayoutEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
}
